import { MAIN_DOMAIN } from './constants';

const title = {
  home: 'Home |',
  setLatihan: 'Set Latihan |',
  binaLatihan: 'Bina Latihan |',
  createBinaLatihan: 'Bina Latihan |',
  harga: 'Harga |',
  affiliate: 'Program Affiliate |',
  blog: 'Blog |',
  signup: 'Daftar Akaun |',
  signin: 'Sign In |',
  aboutUs: 'Tentang Kami | Mysoalan',
  notFound: '404 Not Found | Mysoalan',
  careerPath: 'Career Path | Mysoalan',
  default: '',
};

const titleMeta = {
  home: 'Home | Mysoalan',
  setLatihan: 'Set Latihan | Mysoalan',
  binaLatihan: 'Bina Latihan | Mysoalan',
  createBinaLatihan: 'Bina Latihan | Mysoalan',
  harga: 'Harga | Mysoalan',
  affiliate: 'Program Affiliate | Mysoalan',
  blog: 'Blog | Mysoalan',
  signup: 'Daftar Akaun | Mysoalan',
  signin: 'Sign In | Mysoalan',
  aboutUs: 'Tentang Kami | Mysoalan',
  notFound: '404 Not Found | Mysoalan',
  careerPath: 'Career Path | Mysoalan',
  default: '',
};

const canonical = {
  home: MAIN_DOMAIN,
  setLatihan: MAIN_DOMAIN + '/browse',
  binaLatihan: MAIN_DOMAIN + '/papers',
  createBinaLatihan: MAIN_DOMAIN + '/papers/create',
  harga: MAIN_DOMAIN + '/pricing',
  affiliate: MAIN_DOMAIN + '/program-affiliate',
  blog: MAIN_DOMAIN + '/blog',
  signup: MAIN_DOMAIN + '/signup',
  signin: MAIN_DOMAIN + '/signin',
  aboutUs: MAIN_DOMAIN + '/about-us',
  careerPath: MAIN_DOMAIN + '/get-me-career-path',
  default: MAIN_DOMAIN + '',
};

const description = {
  home:
    'MySoalan adalah satu platform untuk cikgu dan pelajar mendapatkan bahan mengajar, latihan dan soalan.',
  setLatihan:
    'Download soalan SPM, Percubaan SPM, UASA, Ujian akhir sesi akademik, latihan topikal tahun untuk semua subjek dari sekolah rendah hingga sekolah menengah.',
  binaLatihan:
    'Bina kertas exam, latihan dari Bank soalan kami. Semua soalan boleh diubah suai dan boleh disusun semula. Sesuai untuk mendapatkan kertas soalan yang unik.',
  createBinaLatihan:
    'Bina kertas exam, latihan dari Bank soalan kami. Semua soalan boleh diubah suai dan boleh disusun semula. Sesuai untuk mendapatkan kertas soalan yang unik.',
  harga:
    'Untuk menggunakan Mysoalan sepenuhnya, jadilah pengguna premium kami. Dengan menjadi pengguna premium kami, anda boleh memuat turun kertas peperiksaan tanpa had.',
  affiliate:
    'Nak buat extra income? Senang je! Promote MySoalan dekat orang lain dan sesiapa yang melanggan 6 bulan menggunakan link anda, anda akan dapat RM10! RM100 untuk 10 orang!',
  blog:
    'Teroka dan baca berita atau artikel terkini untuk mendapatkan berita terkini, petua dan teknik berkaitan pembelajaran dan cara menggunakan Mysoalan.',
  signup:
    'Daftar Mysoalan sekarang! Kemudian, anda akan dapat memuat turun semua soalan dalam bank soalan kami.',
  signin:
    'Log masuk kembali ke akaun anda dan mula menggunakan Mysoalan semula.',
  aboutUs:
    'MySoalan adalah satu platform untuk cikgu dan pelajar mendapatkan bahan mengajar, latihan dan soalan.',
  notFound:
    'Kami tidak dapat mencapai halaman yang anda minta pada masa ini. Cuba cari yang lain.',
  careerPath:
    'Lepas SPM tapi tak pasti nak buat apa? Jangan risau, kami boleh tolong! Jawab beberapa soalan mudah tentang minat dan subjek kegemaran. Kami akan cadangkan kerjaya yang paling ngam dengan diri korang.',
  default: '',
};

export const pageSEO = { title, titleMeta, canonical, description };
